import React from "react";
import Danger from "../Typography/Danger";

export default function InputErrors(props) {
  return props.errors.map((e, i) => {
    return <Danger key={i}>{e}</Danger>;
  });
}
